import PropTypes from 'prop-types';
import React from 'react';

class MeasureTargetForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedType: "Retailer", options: ["Retailer", "Brand"] };
  }

  handleSelectChange = (event) =>  {
    this.setState({ selectedType: event.target.value });
  }

  findPreviousValue = (targets, measure, item) => {
    const filtered = targets.filter((target)=> ( targets[`${this.state.selectedType.toLowerCase()}_id`] == item.id && target.measure_config_id == measure.id))
 
     if (filtered.length >0) {
       return filtered[0].target
     }
   }

  render() {
    const array = this.state.selectedType === "Retailer" ? this.props.retailers : this.props.brands

    return (
      <div
        id="MeasureTargetForm"
        className="shadow overflow-hidden px-4 py-5 bg-white sm:p-6 sm:rounded-md"
      >
        <div>
          {this.props.measure_target.errors &&
            this.props.measure_target.errors.base.length > 0 && (
              <div id="error_explanation">
                <p>
                  {' '}
                  {this.props.measure_target.errors.base.length > 1
                    ? `${this.props.measure_target.errors.base.length} errors`
                    : '1 error'}{' '}
                  prohibited the weights from being saved:
                </p>
                <ul>
                  {this.props.measure_target.errors.base.map((error) => (
                    <li>{error}</li>
                  ))}
                </ul>
              </div>
            )}
        </div>
        <div className="grid grid-cols-3">
          <div className="col-span-3 grid grid-cols-3 pb-6">
           <h3 className="pr-2 col-span-1 col-start-1 font-medium text-gray-700"> Select a measure target type: </h3>
          <select className="col-span-1 col-start-2 md: mr-6 shadow-sm px-2 sm: border border-gray-300 rounded-md" id={"target_type_select"} onChange={this.handleSelectChange} value={this.state.selectedType}>
                {this.state.options.map((opt, index)=>(<option key={index} value={opt} >{opt}</option>))}
              </select>
          </div>
          <div className="col-span-1 font-medium text-gray-700 typeHeader">{this.state.selectedType}</div>
          <div className="col-span-1 col-start-2 font-medium text-gray-700">
            Measure
          </div>
          <div className="col-span-1 col-start-3 font-medium text-gray-700">
            Target(%)
          </div>
        </div>
        {array.map((item, index) => (
          <div className="grid grid-cols-3 py-3" key={index}>
            <div className="col-span-1">
              <label className="block text-gray-700">{item.name}</label>
            </div>
            {this.props.measures.map((measure, index) => (
              <React.Fragment key={index}>
                <div className="col-start-2">
                  <label className="block  text-gray-700">{measure.name}</label>
                  <input
                    type="hidden"
                    value={measure.id}
                    name="measure_targets[measure_targets][][measure_config_id]"
                    className="measure w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block 
                    "
                  ></input>
                </div>
                <div className="col-start-3">
                  <input
                    type="number"
                    readOnly={false}
                    defaultValue={
                      this.props.measure_target.measure_targets
                      ? this.findPreviousValue(this.props.measure_target.measure_targets, measure, item) : 0
                    }
                    id={`${measure.name}_${item.name}__target`}
                    name="measure_targets[measure_targets][][target]"
                    className="target-percent w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
                  ></input>
                </div>
                <input
                  type="hidden"
                  name={`measure_targets[measure_targets][][${this.state.selectedType.toLowerCase()}_id]`}
                  value={item.id}
                />
                  <input
                  type="hidden"
                  name={`measure_targets[measure_targets][][type]`}
                  value={this.state.selectedType.toLowerCase()}
                />
                <input
                  type="hidden"
                  id={`${measure.name}_measure_targets__client_id`}
                  name="measure_targets[measure_targets][][client_id]"
                  value={this.props.client}
                />
              </React.Fragment>
            ))}
          </div>
        ))}

        <div className="actions">
          <input type="submit" value="Submit" />
          <a class="secondary-btn ml-2" href="/weights_targets">Cancel</a>
        </div>
      </div>
    );
  }
}

MeasureTargetForm.propTypes = {
  client: PropTypes.number,
  retailers: PropTypes.array,
  brand: PropTypes.array,
  measures: PropTypes.array,
};

export default MeasureTargetForm;